const COUNTRY_TIMEZONES = {
  US: "America/New_York",
  CA: "America/Toronto",
  MX: "America/Mexico_City",
  BR: "America/Sao_Paulo",
  AR: "America/Argentina/Buenos_Aires",
  CL: "America/Santiago",
  GB: "Europe/London",
  UK: "Europe/London",
  IE: "Europe/Dublin",
  FR: "Europe/Paris",
  DE: "Europe/Berlin",
  ES: "Europe/Madrid",
  IT: "Europe/Rome",
  NL: "Europe/Amsterdam",
  SE: "Europe/Stockholm",
  NO: "Europe/Oslo",
  DK: "Europe/Copenhagen",
  PL: "Europe/Warsaw",
  RU: "Europe/Moscow",
  TR: "Europe/Istanbul",
  ZA: "Africa/Johannesburg",
  NG: "Africa/Lagos",
  EG: "Africa/Cairo",
  AE: "Asia/Dubai",
  SA: "Asia/Riyadh",
  IN: "Asia/Kolkata",
  PK: "Asia/Karachi",
  BD: "Asia/Dhaka",
  CN: "Asia/Shanghai",
  HK: "Asia/Hong_Kong",
  JP: "Asia/Tokyo",
  KR: "Asia/Seoul",
  SG: "Asia/Singapore",
  ID: "Asia/Jakarta",
  TH: "Asia/Bangkok",
  VN: "Asia/Ho_Chi_Minh",
  PH: "Asia/Manila",
  MY: "Asia/Kuala_Lumpur",
  AU: "Australia/Sydney",
  NZ: "Pacific/Auckland",
};

export const getTimeZoneForCountry = (countryCode) => {
  if (!countryCode) {
    // eslint-disable-next-line no-redeclare
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
  const normalized = countryCode.trim().toUpperCase();
  // eslint-disable-next-line no-redeclare
  return COUNTRY_TIMEZONES[normalized] || Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const getPartsForZone = (date, timeZone) => {
  // eslint-disable-next-line no-redeclare
  const formatter = new Intl.DateTimeFormat("en-US", {
    timeZone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  const parts = formatter.formatToParts(date).reduce((acc, part) => {
    if (part.type !== "literal") {
      acc[part.type] = part.value;
    }
    return acc;
  }, {});

  return {
    year: Number(parts.year),
    month: Number(parts.month),
    day: Number(parts.day),
    hour: Number(parts.hour),
    minute: Number(parts.minute),
    second: Number(parts.second),
  };
};

export const getZonedNowParts = (timeZone) => getPartsForZone(new Date(), timeZone);

export const getZonedParts = (date, timeZone) => getPartsForZone(date, timeZone);

export const zonedLocalToUtcISO = (dateStr, timeStr, timeZone) => {
  const [year, month, day] = dateStr.split("-").map(Number);
  const [hour, minute] = timeStr.split(":").map(Number);
  let guess = new Date(Date.UTC(year, month - 1, day, hour, minute, 0));

  for (let i = 0; i < 2; i += 1) {
    const actual = getPartsForZone(guess, timeZone);
    const desiredMinutes = Date.UTC(year, month - 1, day, hour, minute, 0) / 60000;
    const actualMinutes =
      Date.UTC(actual.year, actual.month - 1, actual.day, actual.hour, actual.minute, 0) / 60000;
    const diffMinutes = desiredMinutes - actualMinutes;
    if (diffMinutes === 0) break;
    guess = new Date(guess.getTime() + diffMinutes * 60000);
  }

  return guess.toISOString();
};

export const formatInTimeZone = (isoString, timeZone) => {
  if (!isoString) return "";
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat("en-US", {
    timeZone,
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};
